module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d78173077f3d3114ca769ae1b6671098.png";